import React, { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import Chip from "../../../components/Chip";
import { Button } from "../../../components/button/Button";
import { ValueItem } from "../../../interfaces/reviewSelectionInterfaces";

interface CollapsibleProps {
  title: string;
  filters: ValueItem[];
  onRemoveFilter: (category: string, filterItem: ValueItem) => void;
  maxVisible?: number;
  incExcMapData:any,
  axesWithAllSelected:string[]
}

const CollapsibleFilers: React.FC<CollapsibleProps> = ({
  title,
  filters,
  onRemoveFilter,
  maxVisible = 3,
  axesWithAllSelected,
  incExcMapData
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const visibleFilters = isCollapsed ? filters.slice(0, maxVisible) : filters;
  const remainingCount = filters.length - maxVisible;

  return (
    <div style={{ display: "flex", gap: 10,paddingRight:"10px", alignItems: "flex-start" }}>
      <div style={{ width: 10, height: 10 }}>
        <FontAwesomeIcon
          onClick={() => setIsOpen(!isOpen)}
          size="2x"
          icon={isOpen ? faChevronDown : faChevronRight}
          style={{ marginTop: 2, cursor: "pointer", fontSize: "12px" }}
        />
      </div>

      <div
        style={{ flex: 1, display: "flex", flexDirection: "column", gap: 5 }}
      >
        <div style={{display:'flex', alignItems:"center",gap:10}}>
          <span
            style={{
              padding: "3px 8px",
              fontSize: 14,
              fontWeight: 500,
              textTransform: "uppercase",
              background: "lightgray",
              borderRadius: 5,
            }}
          >
            {title.slice(1, -1)}
          </span>

            <span
            style={{
              padding: "3px 6px",
              fontSize: 10,
              fontWeight: 500,
              // color:"#fff",
              // textTransform: "uppercase",
              color:`${incExcMapData[title] ? " #424242" : "red"}`,
              background:`${incExcMapData[title] ? " #f1f1f1" : "#ffefef"}`,

              borderRadius: 5,
            }}
          >
            {
              incExcMapData[title] ? "Include" :  "Exclude"
            }
          </span>
        </div>

        {isOpen && (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 5,
              maxHeight: 60,
              overflow: "auto",
              padding: "10px 10px",
              border: "1px dotted lightgray",
              borderRadius: 10,
            }}
          >
            {visibleFilters?.length > 0 &&
              visibleFilters.map((item) => (
                <Chip
                  key={`${item.value}-${item.selType}-${item.namedSet}`}
                  label={item.value}
                  isRoundedFull={true}
                  backgroundColor={item.namedSet ? "#f8f6d2" : "#e1e8f5"}
                  onRemove={() => onRemoveFilter(title, item)}
                />
              ))}
            {isCollapsed && remainingCount > 0 && (
              <Button
                onClick={() => setIsCollapsed(false)}
                variant="plain"
                className=""
              >
                +{remainingCount} more
              </Button>
            )}
            {!isCollapsed && filters.length > maxVisible && (
              <Button
                onClick={() => setIsCollapsed(true)}
                variant="plain"
                className=""
              >
                Show less
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CollapsibleFilers;
